import { AccountDrawerConfiguration } from 'shared-types'

export enum AuthenticationDrawersTypes {
  Login = 'login',
  Register = 'register',
  ForgotPassword = 'forgot-password',
  ResetPassword = 'reset-password',
}

export interface SignUpAuthenticationFormProps {
  setIsSignedUpSuccessfull: React.Dispatch<boolean>
}

export interface AuthenticationDrawerContentProps {
  onClose: (isRedirect?: boolean) => void
  enabledPaymentMethods?: string[]
  accountDrawerConfiguration?: AccountDrawerConfiguration
}
